import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageScrollerLoaderDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        pointerEvents: "none",
        position: "absolute",
        alignItems: "center",
        flexDirection: "row",
        start: 0,
        end: 0,
        top: 0
    }
});

export const useStyles = ({
    controlHeights,
    shapeConfigs,
    spaces
}: MessageScrollerLoaderDynamicStyleType) => {
    const styles = {
        container: {
            zIndex: shapeConfigs.layers.raised,
            height: controlHeights.large,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
